<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition', 'pa-park-note-delete-confirm-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .15}"
   :isFreez="isFreezModal"
   contentTransitionName="trans-content"

   @closeOverlayModal="handleCloseOverlay"
  >
    <PaWideModalBox
     :confirmButtonText="buttonText"
     :isSubmitLoading="isSubmitLoading"

     @handleSubmit="handleClickSubmitButton"
     @handleCancel="handleClickCancelButton"
    >
      <template v-slot:title>{{title}}</template>
      <template v-slot:description>{{description}}</template>
      <template v-slot:caption>{{caption}}</template>
      <template v-slot:messageTitle><span class="bold">―</span>&nbsp;御注意事項&nbsp;<span class="bold">―</span></template>
      <template v-slot:message>{{message}}</template>
    </PaWideModalBox>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PaWideModalBox from '@/components/Parts/PAWideModalBox/PAWideModalBox.vue'

import {DeleteParkNote} from '@/graphql/mutations/ParkNote.graphql'
import {DeleteParkNoteComment} from '@/graphql/mutations/ParkNoteComment.graphql'

import {GetParkNote} from '@/graphql/queries/ParkNote.graphql'

export default {
  components : {
    PaOverlayModal,
    PaWideModalBox
  },
  
  data(){
    return {
      title           : '',
      description     : '',
      caption         : '',
      message         : '',
      buttonText      : '',

      storyScripts        : {
        deleteNote : {
          title         : '掲示物を削除する',
          description   : '掲示物「[[title]]」を完全に削除します。',
          caption       : '削除にあたり消費されるアイテムはありません。',
          message       : '一度削除を実行すると復元することができません。',
          buttonText    : '掲示物を削除する'
        },

        deleteNoteComment : {
          title         : 'コメントを削除する',
          description   : '掲示物「[[title]]」へのコメントを削除します。',
          caption       : '削除にあたり消費されるアイテムはありません。',
          message       : '一度削除を実行すると復元することができません。',
          buttonText    : 'コメントを削除する'
        }
      },
    };
  },
  
  computed : {
    parkId(){
      return this.$route.params.parkId;
    },

    isOpenModal(){
      return this.$store.state.parkNoteDeleteModal.isOpenModal;
    },

    isFreezModal(){
      return this.$store.state.parkNoteDeleteModal.isFreezModal;
    },

    isSubmitLoading(){
      return this.$store.state.parkNoteDeleteModal.isSubmitLoading;
    },

    behaviour(){
      return this.$store.state.parkNoteDeleteModal.behaviour;
    },

    parkNote(){
      return this.$store.state.parkNoteDeleteModal.parkNote;
    },

    parkNoteComment(){
      return this.$store.state.parkNoteDeleteModal.parkNoteComment;
    },

    parkNoteId(){
      if(this.parkNote !== null){
        if(typeof this.parkNote.id !== 'undefined'){
          return this.parkNote.id;
        }
      }

      return null;
    }
  },

  apollo : {
    parkNote : {
      query : GetParkNote,
      variables(){
        return {
          id : this.parkNoteId
        };
      },

      skip(){
        if(this.parkNoteId === null){
          return true;
        }else{
          return false;
        }
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    behaviour : {
      handler(){
        this.updateTextData();
      },
      immediate: true
    },

    parkNote : {
      handler(){
        this.updateTextData();
      },
      immediate: true
    },

    parkNoteComment : {
      handler(){
        this.updateTextData();
      },
      immediate: true
    }
  },

  methods : {
    updateTextData(){
      this.title        = this.textReplacer(this.storyScripts[this.behaviour].title, this.parkNote);
      this.description  = this.textReplacer(this.storyScripts[this.behaviour].description, this.parkNote);
      this.caption      = this.textReplacer(this.storyScripts[this.behaviour].caption, this.parkNote);
      this.message      = this.textReplacer(this.storyScripts[this.behaviour].message, this.parkNote);
      this.buttonText   = this.textReplacer(this.storyScripts[this.behaviour].buttonText, this.parkNote);
    },

    closeModal(){
      this.$store.dispatch({
        type            : 'parkNoteDeleteModal/updateModal',
        isOpen          : false,
        isFreezModal    : false,
        isSubmitLoading : false,
        behaviour       : 'deleteNote',
        parkNote        : null,
        parkNoteComment : null
      });
    },

    handleCloseOverlay(){
      this.closeModal();
    },

    handleClickCancelButton(){
      this.closeModal();
    },

    async handleClickSubmitButton(){
      this.$store.dispatch({
        type            : 'parkNoteDeleteModal/updateModal',
        isSubmitLoading : true,
      });

      let jumpingRoute = null;

      await this.UXWaiting(1000);

      switch(this.behaviour){
        case 'deleteNote':
          if(this.parkNote.could_delete === true){
            await this.executeDeleteParkNote();

            jumpingRoute = {
              name    : 'parks.detail',
              params  : {
                parkId : this.parkId
              }
            };
          }
        break;
        
        case 'deleteNoteComment':
          if(this.parkNoteComment.could_delete === true){
            await this.executeDeleteParkNoteComment();
          }
        break;
      }

      this.closeModal();

      this.$nextTick(() => {
        if(jumpingRoute !== null){
          this.$router.push(jumpingRoute);
        }
      });
    },

    async executeDeleteParkNote(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : DeleteParkNote,
          variables : {
            parkNoteId  : this.parkNote.id,
          }
        }).then(async ({data:{DeleteParkNote:{status}}}) => {
          await this.UXWaiting(500);

          if(status === false){
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;エラーが発生しました。',
              status      : 'error',
              hasControl  : true,
              autoClose   : 8000
            }, {root:true});
          }else{
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;掲示物を削除しました。',
              status      : 'primary',
              hasControl  : true,
              autoClose   : 8000
            }, {root:true});
          }
          
          resolve(true);
        }).catch(async (err) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
          this.apolloResultValidation(simpleErrorSet);

          resolve(false);
        });
      });
    },

    async executeDeleteParkNoteComment(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : DeleteParkNoteComment,
          variables : {
            parkNoteCommentId  : this.parkNoteComment.id,
          }
        }).then(async ({data:{DeleteParkNoteComment:{status}}}) => {
          this.$apollo.queries.parkNote.refetch();

          await this.UXWaiting(500);

          if(status === false){
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;エラーが発生しました。',
              status      : 'error',
              hasControl  : true,
              autoClose   : 8000
            }, {root:true});
          }else{
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;コメントを削除しました。',
              status      : 'primary',
              hasControl  : true,
              autoClose   : 8000
            }, {root:true});

            this.$store.dispatch({
              type              : 'parkNoteComment/deleteParkNoteCommentData',
              parkNoteId        : this.parkNote.id,
              parkNoteCommentId : this.parkNoteComment.id
            });
          }
          
          resolve(true);
        }).catch(async (err) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
          this.apolloResultValidation(simpleErrorSet);

          resolve(false);
        });
      });
    }
  }
}
</script>